import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "../components/Header/Navbar";
import Sidebar from "../components/Header/Sidebar";
import { twMerge } from "tailwind-merge";
import { sideBarOptions } from "../config/sideBarOptions";

function RootLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [smallScreen, setIsSmallScreen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1280);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="flex flex-row h-screen w-full overflow-hidden min-w-[320px] overflow-x-hidden">
        <div
          style={{ minHeight: "654px" }}
          className={twMerge(
            "xl:min-w-[256px]",
            smallScreen && isSidebarOpen
              ? "max-xl:fixed max-xl:bottom-0 max-xl:top-0 max-xl:h-screen max-xl:z-50 min-w-[256px]"
              : "h-0 w-0"
          )}
        >
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            smallScreen={smallScreen}
            Menus={sideBarOptions}
          />
        </div>
        <div className="flex flex-col flex-grow  w-full">
          <Navbar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
          <main className="flex flex-grow w-full overflow-y-auto ">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
}

export default RootLayout;